import styled from 'styled-components'

const StylesIntakeStatus = styled.div`
  float: right;
  margin-bottom: 10px;
  font-weight: 300;
  font-size: 14px;
  .fas {
    padding: 0 5px;
  }

  .fa-user-edit {
    color: green;
  }
  .fa-user-lock {
    color: red;
  }

  .fa-clock{
    color: orange:
  }
`
export const IntakeStatus = ({ vacancyCount }: { vacancyCount: number }) => {
  const status =
    vacancyCount < 10 && vacancyCount > 1
      ? { label: 'Almost Full', icon: 'fa-clock' }
      : vacancyCount <= 0
      ? { label: 'No Spots Available', icon: 'fa-user-lock' }
      : { label: 'Spots Available', icon: 'fa-user-edit' }

  return (
    <StylesIntakeStatus>
      <label className="status">
        <i className={`fas ${status.icon}`}></i>
        {status.label}
      </label>
    </StylesIntakeStatus>
  )
}
